import React from "react";
import { box, Flex } from "@singlestore/fusion/components/layout";

import { DocumentNavMenu } from "components/layout/DocumentNavMenu/DocumentNavMenu";
import {
    SignInButton,
    TryFreeButton,
} from "components/layout/Navigation/CTAButtons";
import { SearchBar } from "components/SearchBar/SearchBar";
import { ThemeSelect } from "components/ThemeSelect/ThemeSelect";

import "./MobileMenu.scss";

export function MobileMenu() {
    return (
        <div className="mobile-menu container">
            <Flex alignItems="center" mb="1x">
                <SignInButton className={box({ mr: "0-5x" })} />
                <TryFreeButton className={box({ mr: "auto" })} />

                <ThemeSelect />
            </Flex>

            <SearchBar />

            <div className="mobile-navigation">
                <DocumentNavMenu />
            </div>
        </div>
    );
}
